function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4556",
  "data-name": "Group 4556",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2360",
  "data-name": "Path 2360",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2361",
  "data-name": "Path 2361",
  d: "M8 11.333l10.223-6.815a.5.5 0 01.777.416v14.132a.5.5 0 01-.777.416L8 12.667V19a1 1 0 01-2 0V5a1 1 0 012 0z",
  fill: "#fff"
})));